class TitleHeightEqualizer {
  constructor(columnsSelector, titleSelector) {
    this.columnsSelector = columnsSelector;
    this.titleSelector = titleSelector;
    this.columns = document.querySelectorAll(this.columnsSelector);

    if(this.columns) {
      this.equalizeTitleHeights();
    }
  }

  equalizeTitleHeights() {
    this.columns.forEach(column => {
      const titles = column.querySelectorAll(this.titleSelector);
      let maxHeight = 0;

      titles.forEach(title => {
        title.style.height = 'auto';
      });

      titles.forEach(title => {
        const titleHeight = title.offsetHeight;
        maxHeight = Math.max(maxHeight, titleHeight);
      });

      titles.forEach(title => {
        title.style.height = `${maxHeight}px`;
      });
    });
  }
}

export default TitleHeightEqualizer;
